<template>
  <div :class="{'app-page': true, 'app-page--with-texture': inHome }">
    <div class="the-header" v-if="inCareering || inRole || inATM">
      <HeaderLogo />
    </div>

    <router-view v-slot="{ Component }">
      <!--<transition name="fade" mode="out-in"> -->
        <component :is="Component" />
      <!--</transition>-->
    </router-view>

    <transition name="fade" mode="out-in">
      <Footer v-show="(inCareering && !inRole) || inATM" />
    </transition>
  </div>
</template>

<script>
import HeaderLogo from "./components/HeaderLogo.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    HeaderLogo,
    Footer,
  },
  data() {
    return {};
  },
  computed: {
    inCareering() {
      return this.$route.path.includes("/careering") ? true : false;
    },
    inRole() {
      // Split the current route into segments
      const pathSegments = this.$route.path.split("/");
      // Check if the first segment is 'careering' and there is a second segment
      if (pathSegments.length > 2) {
        return pathSegments[1] === "careering" && pathSegments[2] !== "";
      }
      return false;
    },
    inHome() {
      // Split the current route into segments
      const pathSegments = this.$route.path.split("/");
      // Check if the first segment is 'careering' and there is a second segment
      if (pathSegments.length === 2) {
        return pathSegments[0] === "" && pathSegments[1] === "";
      }

      return false;
    },
    inATM() {
      return this.$route.path.includes("/atm") ? true : false;
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      window.prerenderReady = true;
    }, 3000);
  },
  methods: {},
  head() {
    return {
      title: "USB Club",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "USB Club",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "A social file exchange.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:image",
          content: "https://usb.club/figures/og/usbclubOG.png",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "A social file exchange.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "description",
          content: "A social file exchange.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "USB Club",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "title",
          content: "USB Club",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:image",
          content: "https://usb.club/figures/og/usbclubOG.png",
        },
        {
          name: "image",
          content: "https://usb.club/figures/og/usbclubOG.png",
        }
      ],
    };
  },
};
</script>

<style>

@import './assets/index.css';

body,
html {
  --color-background: #1c1c1c;
  /* --color-background: #000; */
  background: var(--color-background);
  height: 100%;
  margin: 0;
  color: #EBEBEB;
  font-family: "Untitled Sans";
  font-weight: 400;
  font-size: 10px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

p {
  color: #EBEBEB;
  font-family: "Untitled Sans", sans-serif;
  font-size: 1.6rem;
  line-height: 150%;
  margin: 0;
}

.p1 {
  color: #F6F6F6;
  font-family: "Untitled Sans", sans-serif;
  font-size: 2.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  margin: 0;
}

.p2 {
  color: #EBEBEB;
  font-family: "Untitled Sans", sans-serif;
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
}

.p3,
ul {
  color: #DEDEDE;
  font-family: "Untitled Sans", sans-serif;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
}

.p3 b {
  color: #EBEBEB;
  font-weight: 600;
}

ul {
  margin-block-start: 0.8rem;
  padding-inline-start: 2.8rem;
}

ul li {
  margin-bottom: 0.8rem;
}

h2.careering {
  color: #FFFFFF;
  font-family: "Rowdies", serif;
  font-size: 3.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin: 0;
  margin-bottom: 0.4rem;
}

h3 {
  color: #FFFFFF;
  font-family: "Rowdies", serif;
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin: 0;
  margin-bottom: 0.4rem;
}

/* h3 {
  color: #DEDEDE;
  font-family: "Untitled Sans", sans-serif;
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin: 0;
} */

h4 {
  color: #DEDEDE;
  font-family: "Untitled Sans", sans-serif;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  margin: 0;
  margin-bottom: 0.8rem;
}

h4.subtle {
  font-family: 'Untitled Serif', serif;
  color: #a9a9a9;
  font-size: 16px;
  letter-spacing: -0.5px;
  font-weight: 400;
}

p + h4.subtle {
  margin-top: 8px;
}

a2 {
  color: #FFFFFF;
  font-family: "ISO";
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

.email {
  font-family: "ISO", monospace;
  color: #93CBF4;
}

@media screen and (max-width: 600px) {
  h2.careering {
    font-size: 3.2rem;
  }

  .p1 {
    font-size: 2rem;
  }

  .p3,
  ul {
    font-size: 1.6rem;
  }

  ul {
    padding-inline-start: 2.2rem;
  }
}

input {
  font-family: "ISO";
  font-weight: 400;
}

.app-page {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
}

.app-page--with-texture {
  background-image: url('/figures/background-texture.png');
  background-size: 100% auto;
  background-repeat: repeat-y;
  background-blend-mode: difference;
}

.page-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.padded-width {
  position: relative;
  padding-left: 24px;
  padding-right: 24px;
  width: 100%;
  max-width: 490px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.padded-width.align-left {
  align-items: flex-start;
}

a.button:visited {
  color: #E9E9E9;
  color: #CFCFCF;
}

.button {
  --top-shadow-distance: 4px;
  color: #E9E9E9;
  color: #CFCFCF;
  font-family: "ISO";
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 150%;
  padding-top: 1.2rem;
  padding-right: 1.8rem;
  padding-bottom: 1.2rem;
  padding-left: 1.8rem;
  text-align: center;
  width: 100%;
  background: #2D2D2D;
  /* border: 1px solid #131313; */
  border: none;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.35),
    inset 0px
      var(--top-shadow-distance) 7px #484848,
        inset 0px -4px 5.91837px rgba(0, 0, 0, 0.35);
  border-radius: 8px;
  box-sizing: border-box;
  -webkit-appearance: none;
  transition: all 150ms ease-in-out;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
}

.button.fit {
  width: fit-content;
}

.button span {
  color: #a5a5a5;
  transition: all 150ms ease-in-out;
  transform: scale(0.9);
  transform-origin: center center;
  display: inline-block;
}

a.button:hover {
  color: #ffffff;
}

.button:hover {
  cursor: pointer;
  box-shadow: 0px 7px 9px rgba(0, 0, 0, 0.55),
    inset 0px
      var(--top-shadow-distance) 7px #484848,
        inset 0px -4px 5.91837px rgba(0, 0, 0, 0.35);
  color: #ffffff;
  /* border: 1px solid #AEAEAE; */
}

.button:active {
  color: #989898;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0),
    inset 0px calc(var(--top-shadow-distance) - 9px) 5px rgba(72, 72, 72, 0.6),
    inset 0px 7px 5.91837px rgba(0, 0, 0, 0.36);
  /* box-shadow: 0px 0px 0px rgba(0, 0, 0, 0),
    inset 0px -2px 5px rgba(72, 72, 72, 0.6),
    inset 0px 7px 5.91837px rgba(0, 0, 0, 0.36); */
}

.button:hover span {
  color: #fff;
  transform: scale(1);
}

.button:active span {
  color: #989898;
  transform: scale(0.75);
}

.shine {
  color: rgba(255, 255, 255, 0.6);
  text-shadow: 0 0px 0px rgba(255, 255, 255, 0.3);

  background: #222 -webkit-gradient(linear, left top, right top, from(#222), to(#222), color-stop(0.5, #fff)) 0 0 no-repeat;
  -webkit-background-size: 65px;
  background-size: 65px;
  width: 100%;

  -webkit-background-clip: text;
  background-clip: text;

  -webkit-animation-name: shiner;
  -webkit-animation-duration: 3000ms;
  -webkit-animation-iteration-count: infinite;

  animation-name: shiner;
  animation-duration: 3000ms;
  animation-iteration-count: infinite;

  transition: color 200ms ease-in-out;
}

.shine:hover,
a.button:hover .shine {
  color: rgba(255, 255, 255, 0.8);
}

@-webkit-keyframes shiner {
  0% {
    background-position: -50px;
  }

  80%,
  100% {
    background-position: 200px;
  }
}

.phone-input {
  background: #EBEBEB;
  -webkit-appearance: none;
  box-shadow: inset 0px -5px 3px rgb(255 255 255 / 85%),
    inset 0px 4px 5px rgb(0 0 0 / 26%);
  border-radius: 8px;
  font-size: 16px;
  font-family: "Good", sans-serif;
  line-height: 150%;
  padding-top: 8px;
  padding-bottom: 8px;
  border: none;
  width: 250px;
}

.name-input {
  width: 100%;
  box-sizing: border-box;
  padding-left: 9px;
  margin-bottom: 12px;
}

.iti__country-list {
  color: black;
  font-family: "Good", sans-serif;
}

.buttony {
  position: absolute;
  opacity: 1;
  transition: all 300ms ease-in-out;
}

.buttony.hide-button {
  pointer-events: none;
  opacity: 0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
}

.center.hide-homepage {
  opacity: 0;
  display: none;
}

.formy {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: all 300ms ease-in-out;
  transition-delay: 100ms;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
  width: 250px;
  display: flex;
  flex-direction: column;
}

.formy.show-form {
  opacity: 1;
  pointer-events: all;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  user-select: text;
}

.message {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: all 300ms ease-in-out;
  transition-delay: 150ms;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  user-select: none;
  text-align: center;
}

.message.show-success {
  opacity: 1;
  pointer-events: all;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  user-select: text;
}

.message.show-error {
  opacity: 1;
  pointer-events: all;
  -webkit-touch-callout: text; /* iOS Safari */
  -webkit-user-select: text; /* Safari */
  user-select: text;
}

.message .label {
  font-family: "ISO", monospace;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-size: 14px;
  line-height: 150%;
  margin-bottom: 4px;
}

.message .note {
  font-family: "Good", sans-serif;
  font-size: 18px;
  line-height: 150%;
  margin-top: 0;
}

#app {
  height: 100%;
}

.one-pager {
  text-align: center;
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 120px;
}

.one-pager.fullpage {
  grid-template-rows: 1fr;
}

.one-pager.fullpage .by {
  display: none;
}

.center {
  height: 100%;
  max-height: 100%;
  width: 100%;
  /* padding-top: 60px; */

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
}

.logo svg {
  height: 52px;
  width: auto;
}

a,
a:visited {
  color: rgba(255, 255, 255, 0.8);
}

a:hover {
  color: white;
  text-decoration: none;
}

.register-container {
  display: none;
}

.register-container.show-register {
  display: flex;
  flex-direction: column;
}

.register-container,
#register-form {
  width: 100%;
  height: 100%;
}

.callout {
  background: linear-gradient(180deg, #252525 0%, #151515 100%);
  border: 1px solid rgb(27 27 27);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  padding: 20px;
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 240px;
}

.callout .code {
  font-size: 24px;
  line-height: 150%;
  padding: 0;
  margin: 0;
}

.callout .note {
  font-size: 16px;
  color: #D8D8D8;
  margin-bottom: 8px;
}

.submitted-label {
  margin-top: 0;
}

.for-atm {
  display: none;
}

.for-atm.atm-show {
  display: block;
}

.atm-hide {
  display: none;
}

.about-section {
  text-align: left;
  margin-top: 80px;
}

.about-section .label {
  color: #DDEDFF;
  font-size: 16px;
  font-family: "ISO", monospace;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.features {
  display: flex;
  flex-direction: row;
  grid-gap: 16px;
  margin-bottom: 16px;
}

.feature {
  display: flex;
  flex-direction: row;
  align-items: center;
  grid-gap: 8px;
}

.feature-icon {
  display: flex;
}

.feature-label {
  color: #FFF;
  font-size: 16px;
  font-family: "Good", sans-serif;
  font-weight: 450;
  line-height: 150%;
}

.feature-title-padded {
  display: inline-block;
  margin-left: 5px;
}

p.faded {
  color: #999999;
}

p.faded a {
  color: #999999;
}

p.faded a:hover {
  color: #fff;
}

p a {
  transition: color 100ms ease-in-out;
}

.team-item {
  border-bottom: 1px solid #5F5F5F;
  margin-bottom: 24px;
  padding-bottom: 24px;
}

.team-item p {
  margin: 0;
  padding: 0;
}

.team-item:last-child {
  border-bottom: none;
}

.about-section .image-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.about-section img {
  max-width: 260px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-enter-from {
  opacity: 0;
  transform: translate(0px, 1.2rem);
  transition-delay: 50ms;
}

.fade-enter-to {
  opacity: 1;
  transform: translate(0px, 0px);
}

.fade-leave-from {
  opacity: 1;
  transform: translate(0px, 0px);
}

.fade-leave-to {
  opacity: 0;
  transform: translate(0px, 1.2rem);
}

.role-page.fade-enter-active {
  transition-delay: 500ms;
}

.careering.fade-enter-active {
  transition-delay: 200ms;
}

.the-header {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.the-header .electricity {
  position: absolute;
}
</style>
